import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FreelancerLayout from "../../layouts/FreelancerLayout";
import { fetchfreelancerProfile } from "../../redux/features/find-a-job/actions/authAction";
import Loader from "../../components/loader";
import { getProfile } from "../../utils/pip";
const Workshop = () => {
  const { subLoading } = useSelector((state) => state.freelancer.auth);

  if (subLoading) {
    return <Loader />;
  }
  return (
    <div>
      <FreelancerLayout>
        <div className="ct_px_40 my-5">
          <div className="container-fluid">
            <div className="row gx-5">
              <div className="col-xxl-3 col-xl-4 col-lg-4 mb-4">
                <div>
                  <div className="ct_outline_bg ct_p_20 ct_box_shadow_card_1 ct_border_radius_10">
                    <div className="d-flex align-items-center justify-content-between gap-3 ct_mb_10">
                      <div>
                        <img
                          src="/assets/img/user_profile.png"
                          className="ct_img_56"
                        />
                      </div>
                      <div>
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.75 20.25V17.7708L17.45 10.0854C17.5667 9.97847 17.6956 9.89583 17.8368 9.8375C17.9779 9.77917 18.1261 9.75 18.2812 9.75C18.4364 9.75 18.5871 9.77917 18.7333 9.8375C18.8796 9.89583 19.0059 9.98333 19.1125 10.1L19.9146 10.9167C20.0312 11.0236 20.1164 11.15 20.1701 11.2958C20.2238 11.4417 20.2504 11.5875 20.25 11.7333C20.25 11.8889 20.2234 12.0373 20.1701 12.1784C20.1168 12.3196 20.0316 12.4483 19.9146 12.5646L12.2292 20.25H9.75ZM18.2667 12.55L19.0833 11.7333L18.2667 10.9167L17.45 11.7333L18.2667 12.55Z"
                            fill="#535862"
                          />
                        </svg>
                      </div>
                    </div>
                    <h6 className="ct_fs_16 ct_darkblue_text mb-1">
                      Alex Brown
                    </h6>
                    <p className="ct_fs_14">Los Angeles, CA 90045</p>
                    <ul className="ct_mb_16">
                      <li className="d-flex align-items-center gap-2 justify-content-between">
                        <p className="mb-0 ct_fs_14 ct_grey_text ct_white_nowrap">
                          Most Recent Job
                        </p>
                        <p className="mb-0 ct_fs_14 ct_grey_text text-truncate ct_darkblue_text">
                          CodeNest
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-2 justify-content-between ct_mt_16">
                        <p className="mb-0 ct_fs_14 ct_grey_text ct_white_nowrap">
                          Last Qualification
                        </p>
                        <p className="mb-0 ct_fs_14 ct_grey_text text-truncate ct_darkblue_text">
                          UI/UX Designer
                        </p>
                      </li>
                      <li className="d-flex align-items-center gap-2 justify-content-between ct_mt_16">
                        <p className="mb-0 ct_fs_14 ct_grey_text ct_white_nowrap">
                          Work Experience
                        </p>
                        <p className="mb-0 ct_fs_14 ct_grey_text text-truncate ct_darkblue_text">
                          5.5 Years
                        </p>
                      </li>
                    </ul>
                    <div className="d-flex align-items-center gap-2">
                      <img src="../assets/img/grey_mail_icon.svg" />
                      <p className="mb-0 ct_fs_14 ct_grey_text">
                        alexbrown@gmail.com
                      </p>
                    </div>
                    <div className="d-flex align-items-center ct_mt_10 gap-2">
                      <img src="../assets/img/grey_phon_icon.svg" />
                      <p className="mb-0 ct_fs_14 ct_grey_text">1234567891</p>
                    </div>

                    <div className="ct_mt_27">
                      <button className="ct_yellow_btn ct_h_37 w-100 ct_fs_14">
                        Edit Profile
                      </button>
                    </div>
                  </div>

                  <div className="ct_mt_40">
                    <ul>
                      <li>
                        <div className="ct_outline_bg ct_box_shadow_card_1 ct_p_10 ct_border_radius_10">
                          <p className="mb-0 ct_fs_16 ct_darkblue_text">
                            Jobs Applied (4)
                          </p>
                        </div>
                      </li>
                      <li className="mt-4">
                        <div
                          className="ct_outline_bg ct_box_shadow_card_1 ct_p_10 ct_border_radius_10"
                          style={{ backgroundColor: "#8ECAE6" }}
                        >
                          <p className="mb-0 ct_fs_16 ct_darkblue_text">
                            Saved Jobs (4)
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="ct_mt_40 ct_outline_bg ct_box_shadow_card_1 ct_border_radius_10 ct_p_20 text-center">
                    <h5 className="ct_fs_16 ct_darkblue_text ct_mb_16">
                      Don’t Miss Any Update
                    </h5>
                    <p
                      className="ct_fs_14 ct_grey_text mb-0 mx-auto"
                      style={{ maxWidth: "253px" }}
                    >
                      Be the first to know about upcoming events, remote work,
                      courses, and everything about hiring and working better
                    </p>
                    <div className="mt-4">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control ct_input  ct_h_37"
                          placeholder="Enter Email"
                        />
                      </div>
                      <div className="ct_mt_20">
                        <button className="ct_yellow_btn ct_darkblue_btn ct_fs_14 w-100">
                          Subscribe
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xxl-8 col-xl-7 col-lg-7 mb-4">
                <div className="    h-100">
                  <ul className="d-flex align-items-center gap-5">
                    <li className="ct_grey_text ">Coaching </li>
                    <li className="ct_grey_text ">Ebooks </li>
                    <li className="ct_grey_text ct_darkblue_text">Workshop </li>
                  </ul>

                  <div className="ct_mt_30">
                    <h4 className="ct_fs_20 ct_darkblue_text mb-0">
                      My Workshop
                    </h4>
                    <div className="row ct_mt_20">
                      <div className="col-lg-4 col-md-6 mb-4">
                        <figure className="ct_my_ebook_card">
                          <img src="../assets/img/book_2.png" />

                          <figcaption className="ct_mt_20">
                            <h4
                              className="ct_fs_16 ct_darkblue_text ct_mb_10 ct_para_scroll ct_custom_scroll"
                              style={{ maxHeight: "80px" }}
                            >
                              Crafting a Portfolio that Wins Clients
                            </h4>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src="../assets/img/Avatar_11.png"
                                  className="ct_img_40"
                                />
                                <div>
                                  <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                                    Nuray Aksoy
                                  </h5>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    Founder Coach
                                  </p>
                                </div>
                              </div>
                              <div>
                                <h6 className="ct_fs_12 ct_darkblue_text ct_mb_10">Jun 18, 2025</h6>
                                <p className="ct_fs_12 ct_orange_text mb-0">4:00PM CET</p>
                              </div>
                            </div>
                          </figcaption>
                          <div class="ct_mt_20 d-flex align-items-center justify-content-between">
                            <p className="mb-0 ct_fs_12 ct_darkblue_text">Zoom. 90 minutes. </p>
                            <p className="mb-0 ct_fs_12 ct_darkblue_text"><span className="ct_dot_10 me-1" style={{ backgroundColor: "var(--yellow)" }}></span>Registered</p>
                          </div>
                        </figure>
                      </div>

                      <div className="col-lg-4 col-md-6 mb-4">
                        <figure className="ct_my_ebook_card">
                          <img src="../assets/img/book_2.png" />

                          <figcaption className="ct_mt_20">
                            <h4
                              className="ct_fs_16 ct_darkblue_text ct_mb_10 ct_para_scroll ct_custom_scroll"
                              style={{ maxHeight: "80px" }}
                            >
                              Crafting a Portfolio that Wins Clients
                            </h4>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src="../assets/img/Avatar_11.png"
                                  className="ct_img_40"
                                />
                                <div>
                                  <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                                    Nuray Aksoy
                                  </h5>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    Founder Coach
                                  </p>
                                </div>
                              </div>
                              <div>
                                <h6 className="ct_fs_12 ct_darkblue_text ct_mb_10">Jun 18, 2025</h6>
                                <p className="ct_fs_12 ct_orange_text mb-0">4:00PM CET</p>
                              </div>
                            </div>
                          </figcaption>
                          <div class="ct_mt_20 d-flex align-items-center justify-content-between">
                            <p className="mb-0 ct_fs_12 ct_darkblue_text">Zoom. 90 minutes. </p>
                            <p className="mb-0 ct_fs_12 ct_darkblue_text"><span className="ct_dot_10 me-1" style={{ backgroundColor: "var(--yellow)" }}></span>Registered</p>
                          </div>
                        </figure>
                      </div>

                      <div className="col-lg-4 col-md-6 mb-4">
                        <figure className="ct_my_ebook_card">
                          <img src="../assets/img/book_2.png" />

                          <figcaption className="ct_mt_20">
                            <h4
                              className="ct_fs_16 ct_darkblue_text ct_mb_10 ct_para_scroll ct_custom_scroll"
                              style={{ maxHeight: "80px" }}
                            >
                              Crafting a Portfolio that Wins Clients
                            </h4>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src="../assets/img/Avatar_11.png"
                                  className="ct_img_40"
                                />
                                <div>
                                  <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                                    Nuray Aksoy
                                  </h5>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    Founder Coach
                                  </p>
                                </div>
                              </div>
                              <div>
                                <h6 className="ct_fs_12 ct_darkblue_text ct_mb_10">Jun 18, 2025</h6>
                                <p className="ct_fs_12 ct_orange_text mb-0">4:00PM CET</p>
                              </div>
                            </div>
                          </figcaption>
                          <div class="ct_mt_20 d-flex align-items-center justify-content-between">
                            <p className="mb-0 ct_fs_12 ct_darkblue_text">Zoom. 90 minutes. </p>
                            <p className="mb-0 ct_fs_12 ct_darkblue_text"><span className="ct_dot_10 me-1" style={{ backgroundColor: "var(--yellow)" }}></span>Registered</p>
                          </div>
                        </figure>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-4">
                        <figure className="ct_my_ebook_card">
                          <img src="../assets/img/book_2.png" />

                          <figcaption className="ct_mt_20">
                            <h4
                              className="ct_fs_16 ct_darkblue_text ct_mb_10 ct_para_scroll ct_custom_scroll"
                              style={{ maxHeight: "80px" }}
                            >
                              Crafting a Portfolio that Wins Clients
                            </h4>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src="../assets/img/Avatar_11.png"
                                  className="ct_img_40"
                                />
                                <div>
                                  <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                                    Nuray Aksoy
                                  </h5>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    Founder Coach
                                  </p>
                                </div>
                              </div>
                              <div>
                                <h6 className="ct_fs_12 ct_darkblue_text ct_mb_10">Jun 18, 2025</h6>
                                <p className="ct_fs_12 ct_orange_text mb-0">4:00PM CET</p>
                              </div>
                            </div>
                          </figcaption>
                          <div class="ct_mt_20 d-flex align-items-center justify-content-between">
                            <p className="mb-0 ct_fs_12 ct_darkblue_text">Zoom. 90 minutes. </p>
                            <p className="mb-0 ct_fs_12 ct_darkblue_text"><span className="ct_dot_10 me-1" style={{ backgroundColor: "var(--yellow)" }}></span>Registered</p>
                          </div>
                        </figure>
                      </div>

                      <div className="col-lg-4 col-md-6 mb-4">
                        <figure className="ct_my_ebook_card">
                          <img src="../assets/img/book_2.png" />

                          <figcaption className="ct_mt_20">
                            <h4
                              className="ct_fs_16 ct_darkblue_text ct_mb_10 ct_para_scroll ct_custom_scroll"
                              style={{ maxHeight: "80px" }}
                            >
                              Crafting a Portfolio that Wins Clients
                            </h4>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src="../assets/img/Avatar_11.png"
                                  className="ct_img_40"
                                />
                                <div>
                                  <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                                    Nuray Aksoy
                                  </h5>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    Founder Coach
                                  </p>
                                </div>
                              </div>
                              <div>
                                <h6 className="ct_fs_12 ct_darkblue_text ct_mb_10">Jun 18, 2025</h6>
                                <p className="ct_fs_12 ct_orange_text mb-0">4:00PM CET</p>
                              </div>
                            </div>
                          </figcaption>
                          <div class="ct_mt_20 d-flex align-items-center justify-content-between">
                            <p className="mb-0 ct_fs_12 ct_darkblue_text">Zoom. 90 minutes. </p>
                            <p className="mb-0 ct_fs_12 ct_darkblue_text"><span className="ct_dot_10 me-1" style={{ backgroundColor: "var(--yellow)" }}></span>Registered</p>
                          </div>
                        </figure>
                      </div>

                      <div className="col-lg-4 col-md-6 mb-4">
                        <figure className="ct_my_ebook_card">
                          <img src="../assets/img/book_2.png" />

                          <figcaption className="ct_mt_20">
                            <h4
                              className="ct_fs_16 ct_darkblue_text ct_mb_10 ct_para_scroll ct_custom_scroll"
                              style={{ maxHeight: "80px" }}
                            >
                              Crafting a Portfolio that Wins Clients
                            </h4>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src="../assets/img/Avatar_11.png"
                                  className="ct_img_40"
                                />
                                <div>
                                  <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                                    Nuray Aksoy
                                  </h5>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    Founder Coach
                                  </p>
                                </div>
                              </div>
                              <div>
                                <h6 className="ct_fs_12 ct_darkblue_text ct_mb_10">Jun 18, 2025</h6>
                                <p className="ct_fs_12 ct_orange_text mb-0">4:00PM CET</p>
                              </div>
                            </div>
                          </figcaption>
                          <div class="ct_mt_20 d-flex align-items-center justify-content-between">
                            <p className="mb-0 ct_fs_12 ct_darkblue_text">Zoom. 90 minutes. </p>
                            <p className="mb-0 ct_fs_12 ct_darkblue_text"><span className="ct_dot_10 me-1" style={{ backgroundColor: "var(--yellow)" }}></span>Registered</p>
                          </div>
                        </figure>
                      </div>



                    </div>
                  </div>

                  <div className="mt-2">
                    <h4 className="ct_fs_20 ct_darkblue_text mb-0">
                      Recommended
                    </h4>
                    <div className="row ct_mt_20">
                      <div className="col-lg-4 col-md-6 mb-4">
                        <figure className="ct_my_ebook_card">
                          <img src="../assets/img/book_2.png" />

                          <figcaption className="ct_mt_20">
                            <h4
                              className="ct_fs_16 ct_darkblue_text ct_mb_10 ct_para_scroll ct_custom_scroll"
                              style={{ maxHeight: "80px" }}
                            >
                              Crafting a Portfolio that Wins Clients
                            </h4>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src="../assets/img/Avatar_11.png"
                                  className="ct_img_40"
                                />
                                <div>
                                  <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                                    Nuray Aksoy
                                  </h5>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    Founder Coach
                                  </p>
                                </div>
                              </div>
                              <div>
                                <h6 className="ct_fs_12 ct_darkblue_text ct_mb_10">Jun 18, 2025</h6>
                                <p className="ct_fs_12 ct_orange_text mb-0">4:00PM CET</p>
                              </div>
                            </div>
                          </figcaption>
                          <div class="ct_mt_20">
                            <a
                              href=""
                              class="ct_hover_link_yellow ct_yellow_text ct_fs_14"
                              data-bs-target="#ct_book_download_modal"
                              data-bs-toggle="modal"
                            >
                              Register Now{" "}
                              <i class="fa-solid fa-arrow-right"></i>
                            </a>
                          </div>
                        </figure>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-4">
                        <figure className="ct_my_ebook_card">
                          <img src="../assets/img/book_2.png" />

                          <figcaption className="ct_mt_20">
                            <h4
                              className="ct_fs_16 ct_darkblue_text ct_mb_10 ct_para_scroll ct_custom_scroll"
                              style={{ maxHeight: "80px" }}
                            >
                              Crafting a Portfolio that Wins Clients
                            </h4>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src="../assets/img/Avatar_11.png"
                                  className="ct_img_40"
                                />
                                <div>
                                  <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                                    Nuray Aksoy
                                  </h5>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    Founder Coach
                                  </p>
                                </div>
                              </div>
                              <div>
                                <h6 className="ct_fs_12 ct_darkblue_text ct_mb_10">Jun 18, 2025</h6>
                                <p className="ct_fs_12 ct_orange_text mb-0">4:00PM CET</p>
                              </div>
                            </div>
                          </figcaption>
                          <div class="ct_mt_20">
                            <a
                              href=""
                              class="ct_hover_link_yellow ct_yellow_text ct_fs_14"
                              data-bs-target="#ct_book_download_modal"
                              data-bs-toggle="modal"
                            >
                              Register Now{" "}
                              <i class="fa-solid fa-arrow-right"></i>
                            </a>
                          </div>
                        </figure>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-4">
                        <figure className="ct_my_ebook_card">
                          <img src="../assets/img/book_2.png" />

                          <figcaption className="ct_mt_20">
                            <h4
                              className="ct_fs_16 ct_darkblue_text ct_mb_10 ct_para_scroll ct_custom_scroll"
                              style={{ maxHeight: "80px" }}
                            >
                              Crafting a Portfolio that Wins Clients
                            </h4>
                            <div className="d-flex align-items-center gap-3 justify-content-between">
                              <div className="d-flex align-items-center gap-3">
                                <img
                                  src="../assets/img/Avatar_11.png"
                                  className="ct_img_40"
                                />
                                <div>
                                  <h5 className="ct_fs_14 ct_darkblue_text mb-0">
                                    Nuray Aksoy
                                  </h5>
                                  <p className="mb-0 ct_grey_text ct_fs_12">
                                    Founder Coach
                                  </p>
                                </div>
                              </div>
                              <div>
                                <h6 className="ct_fs_12 ct_darkblue_text ct_mb_10">Jun 18, 2025</h6>
                                <p className="ct_fs_12 ct_orange_text mb-0">4:00PM CET</p>
                              </div>
                            </div>
                          </figcaption>
                          <div class="ct_mt_20">
                            <a
                              href=""
                              class="ct_hover_link_yellow ct_yellow_text ct_fs_14"
                              data-bs-target="#ct_book_download_modal"
                              data-bs-toggle="modal"
                            >
                              Register Now{" "}
                              <i class="fa-solid fa-arrow-right"></i>
                            </a>
                          </div>
                        </figure>
                      </div>


                    </div>
                  </div>

                  {/* Empty Div Section S */}
                  <div className="ct_empty_job_section d-none">
                    <img src="../assets/img/start_looking_job_img.png" />
                    <div className="mt-4 text-center">
                      <h4 className="ct_fs_24 ct_darkblue_text mb-2">
                        Ahh... We’re sorrry
                      </h4>
                      <h4 className="ct_fs_24 ct_darkblue_text mb-2">
                        You have not applied to any job yet
                      </h4>
                      <p className="ct_fs_16 ct_darkblue_text mb-0">
                        Don’t worry. We are here to help you, you can start
                        matching your dream jobs.
                      </p>
                      <div className="ct_mt_30 text-center">
                        <button className="ct_yellow_btn mx-auto">
                          Start Looking for Jobs
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* Empty Div Section E */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </FreelancerLayout>

      {/* Ebook Download modal S */}
      <div
        class="modal fade ct_markas_complete_modal"
        id="ct_book_download_modal"
        tabindex="-1"
        aria-labelledby="ct_book_download_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-5 pt-0">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4
                  class="ct_fs_18 ct_darkblue_text mx-auto"
                  style={{ maxWidth: "191px" }}
                >
                  Ready to Download “From Idea To Action”
                </h4>
                <p
                  className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                  style={{ maxWidth: "346px" }}
                >
                  A step-by-step guide to validate your idea and create a 30-day
                  launch plan.
                </p>
              </div>
              <div class="d-flex align-items-center gap-3 justify-content-center ct_mt_30 ">
                <button
                  class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                  type="button"
                >
                  Explore More
                </button>
                <button
                  class="ct_yellow_btn px-5 ct_h_44"
                  data-bs-target="#ct_you_are_all_set_modal"
                  data-bs-toggle="modal"
                  type="button"
                >
                  Download
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Ebook Download modal E */}

      {/* ct_you_are_all_set_modal Download modal S */}
      <div
        class="modal fade ct_markas_complete_modal"
        id="ct_you_are_all_set_modal"
        tabindex="-1"
        aria-labelledby="ct_you_are_all_set_modalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content ct_border_radius_20">
            <div class="modal-header border-0">
              <button
                type="button"
                class="btn-close ct_circle_close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body pb-5 pt-0">
              <div class="mx-auto d-block text-center ct_mb_20">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24 48C17.6348 48 11.5303 45.4714 7.02944 40.9706C2.52856 36.4697 0 30.3652 0 24C0 17.6348 2.52856 11.5303 7.02944 7.02944C11.5303 2.52856 17.6348 0 24 0C30.3652 0 36.4697 2.52856 40.9706 7.02944C45.4714 11.5303 48 17.6348 48 24C48 30.3652 45.4714 36.4697 40.9706 40.9706C36.4697 45.4714 30.3652 48 24 48ZM19.2 36L40.8 15.6L37.2 12L19.2 28.8L10.8 20.4L7.2 24L19.2 36Z"
                    fill="#FFB703"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h4 class="ct_fs_18 ct_darkblue_text mx-auto">
                  You’re All Set
                </h4>
                <p
                  className="ct_fs-14 ct_grey_text mb-0 mx-auto"
                  style={{ maxWidth: "346px" }}
                >
                  Your eBook is now downloading. We hope it gives you clarity
                  and momentum-right when you need it.
                </p>
              </div>
              <div class="d-flex align-items-center gap-3 justify-content-center ct_mt_30 ">
                <button
                  class="ct_sky_blue_btn ct_yellow_btn ct_outline_grey  px-5 ct_h_44"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button class="ct_yellow_btn px-5 ct_h_44" type="button">
                  Meet the Coach
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* ct_you_are_all_set_modal Download modal E */}
    </div>
  )
}

export default Workshop
